import React from "react";

export default function MobileRecordCard({
  title,
  subtitle,
  badge,
  badgeVariant = "flat",
  highlight,
  fields = [],
  selected,
  onSelect,
  selectable,
  actions,
  variant,
  className = "",
  children,
  onClick,
}) {
  const variantClass =
    variant === "buy"
      ? "pr-mobile-card--buy"
      : variant === "sell"
        ? "pr-mobile-card--sell"
        : "";
  const selectedClass = selected ? " pr-mobile-card--selected" : "";
  const badgeClass = `pr-mobile-card__side--${badgeVariant || "flat"}`;

  return (
    <article
      className={`pr-mobile-card ${variantClass}${selectedClass} ${className}`.trim()}
      onClick={onClick}
      role={onClick ? "button" : undefined}
    >
      {(title || subtitle || badge || selectable || actions) && (
        <header className="pr-mobile-card__head">
          <div className="pr-mobile-card__head-left">
            {selectable && (
              <input
                type="checkbox"
                className="pr-mobile-card__check"
                checked={!!selected}
                onChange={(e) => {
                  e.stopPropagation();
                  onSelect?.();
                }}
                onClick={(e) => e.stopPropagation()}
              />
            )}
            <div className="pr-mobile-card__title-block">
              {title != null && title !== "" && (
                <div className="pr-mobile-card__symbol">{title}</div>
              )}
              {subtitle != null && subtitle !== "" && (
                <div className="pr-mobile-card__meta">{subtitle}</div>
              )}
            </div>
          </div>
          {(badge || actions) && (
            <div className="pr-mobile-card__head-right">
              {badge && (
                <span className={`pr-mobile-card__side ${badgeClass}`}>{badge}</span>
              )}
              {actions}
            </div>
          )}
        </header>
      )}

      {highlight && (
        <div
          className="pr-mobile-card__mtm"
          style={highlight.color ? { color: highlight.color } : undefined}
        >
          <span className="pr-mobile-card__mtm-label">{highlight.label}</span>
          <span>{highlight.value}</span>
        </div>
      )}

      {fields.length > 0 && (
        <div className="pr-mobile-card__grid">
          {fields.map((field, index) => (
            <div
              key={field.key || index}
              className={`pr-mobile-card__cell${field.fullWidth ? " pr-mobile-card__cell--full" : ""}`}
            >
              <span className="pr-mobile-card__label">
                {field.label}
                {field.label ? ": " : ""}
              </span>
              <span
                className={
                  field.tone === "green"
                    ? "col-green"
                    : field.tone === "red"
                      ? "col-red"
                      : field.tone === "blue"
                        ? "col-blue"
                        : field.tone === "muted"
                          ? "col-muted"
                          : undefined
                }
                style={field.style}
              >
                {field.value ?? "—"}
              </span>
            </div>
          ))}
        </div>
      )}

      {children}
    </article>
  );
}
